import React, { useEffect } from "react";
import Login from "../../main-component/LoginPage/Login";
import { useLoginModal } from "../../Context/LoginModalContext";

const LoginModal = () => {
  const { loginModal, closeLoginModal } = useLoginModal();

  useEffect(() => {
    if (!loginModal) return;
    const onKey = (e) => {
      if (e.key === "Escape") closeLoginModal();
    };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [loginModal, closeLoginModal]);

  if (!loginModal) return null;

  return (
    <div
      className="gplgm-backdrop"
      onClick={closeLoginModal}
      role="dialog"
      aria-modal="true"
      aria-labelledby="gplgm-title"
    >
      <div
        className="gplgm-shell"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="gplgm-close"
          onClick={closeLoginModal}
          aria-label="Close"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <Login />
      </div>

      <style>{`
        .gplgm-backdrop {
          position: fixed; inset: 0;
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          z-index: 1600;
          animation: gplgm-fade .2s ease;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        }
        @keyframes gplgm-fade { from { opacity: 0; } to { opacity: 1; } }

        .gplgm-shell {
          position: relative;
          width: 100%;
          max-width: 480px;
          max-height: 92vh;
          overflow-y: auto;
          animation: gplgm-pop .28s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        @keyframes gplgm-pop {
          from { opacity: 0; transform: scale(0.95) translateY(10px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
        .gplgm-shell::-webkit-scrollbar { width: 5px; }
        .gplgm-shell::-webkit-scrollbar-thumb { background: rgba(212,168,87,0.25); border-radius: 999px; }

        .gplgm-close {
          position: absolute;
          top: 14px;
          right: 14px;
          z-index: 5;
          width: 34px; height: 34px;
          background: rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(212, 168, 87, 0.35);
          color: #d4a857;
          border-radius: 9px;
          cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          font-family: inherit;
          transition: background .2s ease, border-color .2s ease, color .2s ease;
        }
        .gplgm-close:hover {
          background: rgba(212, 168, 87, 0.15);
          border-color: rgba(212, 168, 87, 0.55);
          color: #f1cf85;
        }

        @media (max-width: 480px) {
          .gplgm-backdrop { padding: 0; align-items: flex-end; }
          .gplgm-shell {
            max-height: 95vh;
          }
        }
      `}</style>
    </div>
  );
};

export default LoginModal;
